import Joi from 'joi';

export const enableUiTestValidationSchema = {
  enableUiTest: Joi.boolean(),
};
